import * as Rest from "../../Generated/RestClient";
function getAzureResourceId(bot: Rest._BotService) : string {
  
  return bot && bot.ProvisionInfo ?
    `/subscriptions/${bot.ProvisionInfo.SubscriptionId}/resourceGroups/${bot.ProvisionInfo.ResourceGroupName}/providers/Microsoft.Web/sites/${bot.ProvisionInfo.SiteName}`
    : null
}

export default getAzureResourceId;


// WEBPACK FOOTER //
// ./Client/v4/Services/botResourceId.ts